import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, sleep } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentResult() {
  const { result } = useParams();
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [status, setStatus] = useState(result === "success" ? "checking" : "cancel");

  useEffect(() => {
    if (result !== "success") return;
    const sid = params.get("session_id");
    let alive = true;
    (async () => {
      for (let i = 0; i < 15 && alive; i++) {
        try {
          const { data } = await api.get(`/payments/status/${sid}`);
          if (data.payment_status === "paid") { await refresh(); if (alive) setStatus("paid"); return; }
          if (["expired", "failed"].includes(data.payment_status)) { setStatus("failed"); return; }
        } catch { /* retry */ }
        await sleep(2000);
      }
      if (alive) setStatus("pending");
    })();
    return () => { alive = false; };
  }, [result, params, refresh]);

  const view = {
    checking: [Loader2, "Vérification du paiement…", "Encore quelques secondes.", "animate-spin text-primary"],
    paid: [CheckCircle2, "Abonnement activé !", "Merci ! Toutes les fonctionnalités de ton offre sont disponibles.", "text-emerald-500"],
    pending: [Loader2, "Paiement en cours de confirmation", "Ton offre sera activée dès la confirmation de Stripe.", "text-amber-500"],
    failed: [XCircle, "Le paiement n'a pas abouti", "Aucun montant n'a été débité. Tu peux réessayer.", "text-destructive"],
    cancel: [XCircle, "Paiement annulé", "Aucun montant n'a été débité.", "text-muted-foreground"],
  }[status];
  const [Icon, title, text, cls] = view;
  return (
    <div className="flex min-h-screen items-center justify-center px-5" data-testid="payment-result-page">
      <div className="card-flat max-w-md p-10 text-center">
        <Icon className={`mx-auto h-12 w-12 ${cls}`} />
        <h1 className="mt-5 text-2xl font-extrabold" data-testid="payment-status-title">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{text}</p>
        <Link to="/app" data-testid="payment-back-button" className="bg-brand mt-8 inline-block rounded-full px-6 py-3 text-sm font-semibold text-white">Retour à mon espace</Link>
      </div>
    </div>
  );
}
